package com.exura.features.plandefinition.data.repository

import com.exura.features.firebase.domain.repository.UserPrefixedRepository
import com.exura.features.firebase.usecase.GetUserDataPrefixUseCase
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.repository.*

class ProviderPlanDefinitionRepositoryImpl(
    planRepository: BasePlanRepository,
    getUserDataPrefixUseCase: GetUserDataPrefixUseCase,
) : ProviderPlanDefinitionRepository, UserPrefixedRepository<BasePlan, BasePlan> (
    baseRepository = planRepository,
    getDataPrefix = suspend { getUserDataPrefixUseCase() },
    collectionName = FirebaseColls.TREATMENT_PLAN,
)
